// New UI for Invoice models (docs/ui_redesign/14-screen-concepts.md, "Invoice models", option A). Display only.

// The links a model row has, in Classic's order (ManageInvoiceModel.displayActions). kind names the Classic handler:
// view (viewLink_clickHandler), setup (invoiceModelSetupLink_clickHandler), vendorMap (invoiceVendorMapLink_clickHandler),
// vendor (vendorLookupLink_clickHandler), revise (confirmationDialog_openHandler). mode is the link's data-mode.
export function modelActions(row) {
	if (!row) return null;
	const isVendorMap = row.type === 'Vendor Map';
	let version = row.documentModelNameTag ? String(row.documentModelNameTag).replace('v', '') : undefined;
	version = isNaN(version) ? 0 : parseInt(version, 10);
	const viewInvoice = { label: 'View sample', kind: 'view', mode: 'ViewInvoice' }; // R21: "View Invoice" and "View" read alike
	const mapVendor = { label: 'Map Vendor', kind: 'vendorMap', mode: version > 1 ? 'Copy' : 'Map Vendor' };
	const view = isVendorMap ? { label: 'View model', kind: 'vendorMap', mode: 'View' } : { label: 'View model', kind: 'setup', mode: 'View' };
	const edit = { label: 'Edit', kind: 'setup', mode: 'Edit' };
	const copy = { label: 'Copy', kind: 'setup', mode: 'Copy' };
	const revise = { label: 'Revise', kind: 'revise', mode: 'Copy' };
	switch (row.action) {
		case 1: return [viewInvoice, { label: 'New', kind: 'setup', mode: 'New' }];
		case 2: return [viewInvoice, { label: 'Assign Vendor', kind: 'vendor', mode: 'VendorLookup' }];
		case 3: return isVendorMap ? [viewInvoice, mapVendor] : [viewInvoice, edit, copy, { label: 'Assign Vendor', kind: 'vendor', mode: 'VendorLookup' }];
		case 4: return isVendorMap ? [viewInvoice, view, revise] : [viewInvoice, edit, copy, { label: 'Reassign Vendor', kind: 'vendor', mode: 'VendorLookup' }];
		case 5: return isVendorMap ? [viewInvoice, view, revise] : [viewInvoice, view, copy];
		case 6: return [viewInvoice, mapVendor];
		default: return null;
	}
}

// The next step is the one that moves a model forward (New, Assign Vendor, Map Vendor); a finished model's first
// action (View or Edit). View Invoice stays a link beside it, and the rest go in the menu.
const NEXT = ['New', 'Assign Vendor', 'Map Vendor'];
export function splitModelActions(actions) {
	if (!actions) return null;
	const link = actions.find(a => a.kind === 'view');
	const rest = actions.filter(a => a !== link);
	const primary = rest.find(a => NEXT.includes(a.label)) || rest[0] || null;
	return { primary, link, more: rest.filter(a => a !== primary) };
}

// Column order and sizes: the ID and model, its vendor, then type, status, active and actions.
const ORDER = ['id', 'displayModelName', 'documentModelNameTag', 'vendor', 'siteId', 'type', 'modelStatus', 'documentModelIsActive', 'actions'];
const SIZE = {
	id: [0.4, 64], displayModelName: [1.3, 160], documentModelNameTag: [0.4, 64], vendor: [1.6, 190], siteId: [0.5, 80], type: [0.8, 130],
	modelStatus: [0.8, 120], documentModelIsActive: [0, 76], actions: [1.4, 270]
};
const HEADER = { documentModelNameTag: 'Tag', siteId: 'Site', modelStatus: 'Status', displayModelName: 'Model', id: 'ID' };
const NARROW = { id: 56, displayModelName: 128, documentModelNameTag: 56, vendor: 146, siteId: 60, type: 110, modelStatus: 110, actions: 236 }; // fits 1280 without hiding Status
export function arrangeModelColumns(columns, renderActions, narrow = typeof window !== 'undefined' && window.innerWidth <= 1366) {
	if (!Array.isArray(columns)) return columns;
	const rank = c => { const i = ORDER.indexOf(c.field); return i < 0 ? ORDER.length : i; };
	return columns.map((c, i) => [c, i]).sort((a, b) => (rank(a[0]) - rank(b[0])) || (a[1] - b[1])).map(([c]) => {
		if (!c || !SIZE[c.field]) return c;
		const [flex, wide] = SIZE[c.field];
		const minWidth = narrow && NARROW[c.field] ? NARROW[c.field] : wide; // R8: less room at 1366px and below
		const out = { ...c, flex, minWidth, width: flex ? undefined : minWidth, apw2Sized: true };
		if (HEADER[c.field]) out.headerName = HEADER[c.field];
		if (c.field === 'actions') { out.align = 'left'; out.headerAlign = 'left'; out.renderCell = p => renderActions(p.row); }
		return out;
	});
}
